import { isDefined } from "@clipboard-health/util-ts";

/**
 * Resolves the OTA buildId we should report for this session.
 *
 * Prefers the buildId of the applied OTA snapshot when one exists. On a
 * fresh native install no snapshot has been applied yet, so
 * `Deploy.getCurrentVersion()` returns either no value at all or a snapshot
 * with `buildId === ""`. In that case, we fall back to the buildId baked
 * into the JS bundle by the native build pipeline (see
 * `scripts/ota/resolve-bundled-ota-build-id.sh` and `bitrise.yml`),
 * allowing fresh installs to report a buildId matching the JS that
 * actually ships in the binary.
 *
 * Returns an empty string when neither source is available (e.g. local
 * dev, web), matching today's "no OTA buildId" sentinel.
 *
 * Lives in its own file (with zero analytics dependencies) so that
 * `segmentPluginHelper` can use it without creating a circular import via
 * the analytics barrel: `log.ts` already imports `segmentPluginHelper`,
 * and `deviceUtils.ts` imports from the analytics barrel — putting this
 * helper in `deviceUtils.ts` would close that cycle.
 */
export function resolveOtaBuildId(appliedOtaBuildId: string | undefined): string {
  if (isDefined(appliedOtaBuildId) && appliedOtaBuildId !== "") {
    return appliedOtaBuildId;
  }

  return process.env.REACT_APP_BUNDLED_OTA_BUILD_ID ?? "";
}
